import { render } from "./Icon_bar.vue?vue&type=template&id=2205bc7c&scoped=true"
import script from "./Icon_bar.vue?vue&type=script&lang=js"
export * from "./Icon_bar.vue?vue&type=script&lang=js"

import "./Icon_bar.vue?vue&type=style&index=0&id=2205bc7c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2205bc7c"]])

export default __exports__